import { TournamentComparisonPage } from "@/pages/tournament/comparison/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/tournament/compare")({
    component: TournamentComparisonPage,
});
